import { css } from 'styled-components';
import { theme } from '../../../theme/semanticTokens';

export interface InputFieldStatusProps {
  $disabled?: boolean;
  $readOnly?: boolean;
  $error?: boolean;
}

const getBorderColor = (
  { $error, $disabled, $readOnly }: InputFieldStatusProps,
  activeColor: string
) => {
  switch (true) {
    case $error:
      return theme.dime.colors.border.critical;
    case $disabled || $readOnly:
      return theme.dime.colors.border.static;
    default:
      return activeColor;
  }
};

export const getInputTextColor = (hasError?: boolean) =>
  hasError ? theme.dime.colors.text.critical : theme.dime.colors.text.secondary;

export const inputFieldBorderStyle = css<InputFieldStatusProps>`
  border-color: ${(props) => getBorderColor(props, theme.dime.colors.border.static)};
  background-color: ${({ $disabled, $readOnly }) =>
    $disabled || $readOnly
      ? theme.dime.colors.fill.disabled
      : theme.dime.colors.fill.primary};

  &:hover {
    border-color: ${(props) =>
      getBorderColor(props, theme.dime.colors.border.interactive)};
  }

  &:focus,
  &:focus-within {
    border-color: ${(props) =>
      getBorderColor(props, theme.dime.colors.border.interactiveSelected)};
    box-shadow: none;
  }
`;
